module.exports = "/_next/static/images/WebThirdProcess-14be0f312b234ade30b32055b02464bb.png";